import React from 'react'
import PropTypes from 'prop-types'
import Logo from '../../../components/Logo'

export default function Header(props) {
	return (
		<header>
			<div className="content-wrap">
				<Logo />
			</div>
			<div className="progress-step grey-out short">
				<h2 className="step-number">1</h2>
				<p className="step-description">Type in your email address</p>
			</div>
			<div className="progress-step grey-out short">
				<h2 className="step-number">2</h2>
				<p className="step-description">Choose your ad account</p>
			</div>
			<div className="progress-step short">
				<h2 className="step-number">3</h2>
				<p className="step-description">Analyze your results</p>
			</div>
			{props.children}
			<div className="arrowBox lower">
				<div className="arrow"></div>
			</div>
		</header>
	)
}

Header.propTypes = {
	name: PropTypes.string,
	children: PropTypes.element
}



// WEBPACK FOOTER //
// ./src/containers/ReportLoaderTopLeads/components/Header.js